import React from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateField = ({startDate, onChange}) => {
  return (
    <div>
      <DatePicker selected={startDate} onChange={onChange} />
    </div>
  )
}

export default DateField
